class PredictiveSearch extends SearchForm {
  constructor() {
    super(),
      (this.cachedResults = {}),
      (this.predictiveSearchResults = this.querySelector(
        "[data-predictive-search]"
      )),
      (this.allPredictiveSearchInstances =
        document.querySelectorAll("predictive-search")),
      (this.isOpen = !1),
      (this.abortController = new AbortController()),
      (this.searchTerm = ""),
      (this.body = document.querySelector("body")),
      (this.header = document.querySelector(".shopify-section-header")),
      (this.headerBottom = document.querySelector(".header__bottom")),
      (this.promoModal = document.querySelector(".search__modal")),
      (this.collectionList = document.querySelector(
        ".template-404__collections"
      )),
      (this.headerInput = document.querySelector(
        ".header__search .search__input"
      )),
      this.calcHeight(),
      this.setupEventListeners();
  }
  calcHeight() {
    (this.results = document.querySelector(".predictive-search__result-group")),
      (this.resultsTabs = document.querySelector(
        ".predictive-search__result-tabs"
      )),
      this.results &&
        this.results.style.setProperty(
          "--search-height",
          parseInt(this.resultsTabs.getBoundingClientRect().bottom) + "px"
        );
  }
setupEventListeners() {
  this.input.form.addEventListener("submit", this.onFormSubmit.bind(this));
  this.input.addEventListener("focus", this.onFocus.bind(this));
  this.addEventListener("focusout", this.onFocusOut.bind(this));
  this.addEventListener("keyup", this.onKeyup.bind(this));

  // ✅ NEW: Outside click handler
  document.addEventListener("click", (e) => {
    const isInsideSearch = this.contains(e.target);
    const isInsideCustomHeader = e.target.closest(".custom-header-search");
    const isInsideResults = e.target.closest(".predictive-search-results-products-list");

    if (!isInsideSearch && !isInsideCustomHeader && !isInsideResults) {
      document.body.classList.remove('overflow-hidden');
      this.close(true);
    }
  });

//   document.addEventListener("mouseover", (e) => {
//   const isInsideHeader = e.target.closest(".header-wrapper.header--border");

//   if (!isInsideHeader) {
//     document.body.classList.remove('overflow-hidden');
//     this.close(true); // Ensure this is inside a class where `this.close()` is defined
//   }
// });

}

  getQuery() {
    return this.input.value.trim();
  }
  onChange() {
    var e = this.getQuery();
    (this.searchTerm && e.startsWith(this.searchTerm)) ||
      this.querySelector("#predictive-search-results-groups-wrapper")?.remove(),
      this.updateSearchForTerm(this.searchTerm, e),
      (this.searchTerm = e),
      this.searchTerm.length
        ? (this.getSearchResults(this.searchTerm),
          this.getQuery().length
            ? this.hidePromoBlock()
            : this.showPromoBlock())
        : this.close(!0);
  }
  onFormSubmit(e) {
    (this.getQuery().length &&
      !this.querySelector('[aria-selected="true"] a') &&
      !e.submitter.classList.contains("card__link")) ||
      e.preventDefault();
  }
  onFormReset(e) {
    super.onFormReset(e),
      super.shouldResetForm() &&
        ((this.searchTerm = ""),
        this.abortController.abort(),
        (this.abortController = new AbortController()),
        this.closeResults(!0));
  }
  onFocus() {
    var e = this.getQuery();
    this.classList.contains("search-modal__form") &&
      (this.headerBottom &&
        this.headerBottom.classList.add("header__bottom--visible"),
      this.promoModal &&
        this.promoModal.classList.remove("search__modal--hidden"),
      this.collectionList) &&
      this.collectionList.classList.remove("hidden"),
      e.length &&
        (this.searchTerm !== e
          ? this.onChange()
          : "true" === this.getAttribute("results")
          ? (this.open(),
            this.promoModal &&
              this.promoModal.classList.add("search__modal--hidden"),
            this.collectionList && this.collectionList.classList.add("hidden"))
          : this.getSearchResults(this.searchTerm));
  }
  onFocusOut() {
    this.classList.contains("search-modal__form") &&
      this.headerBottom &&
      this.headerBottom.classList.remove("header__bottom--visible"),
      this.classList.contains("search-modal__form") ||
        setTimeout(() => {
          this.contains(document.activeElement) || this.close(!0);
        });
  }
  onBlur() {
    this.headerInput.blur();
  }
  onKeyup(e) {
    switch (
      (this.getQuery().length || this.close(!0), e.preventDefault(), e.code)
    ) {
      case "Enter":
        e.preventDefault(), this.selectOption();
        break;
      case "Escape":
        this.close(!0),
          this.closeResults(clearSearchTerm),
          this.getQuery().length
            ? this.hidePromoBlock()
            : this.showPromoBlock();
    }
  }
  updateSearchForTerm(e, t) {
    var s = this.querySelector("[data-predictive-search-search-for-text]"),
      i = s?.innerText;
    if (i) {
      if (1 < i.matchAll(new RegExp(e, "g")).length) return;
      i = i.replace(e, t);
      s.innerText = i;
    }
    this.getQuery().length ? this.hidePromoBlock() : this.showPromoBlock();
  }
  selectOption() {
    var e = this.querySelector(
      '[aria-selected="true"] a, button[aria-selected="true"]'
    );
    e && e.click();
  }
getSearchResults(e) {
  const query = e.trim();
  const formattedQuery = query.replace(/\s+/g, "-").toLowerCase();
  const isSkuSearch = /^[A-Z0-9\-]+$/i.test(query); // detect SKU-style queries

  this.setLiveRegionLoadingState();

  if (this.cachedResults[formattedQuery]) {
    this.renderSearchResults(this.cachedResults[formattedQuery]);
    this.clickSearchTabs();
    this.calcHeight();
    return;
  }

  if (this.promoModal && this.classList.contains("search-modal__form")) {
    this.promoModal.classList.add("search__modal--hidden");
  }

  if (this.collectionList) {
    this.collectionList.classList.add("hidden");
  }

  // Always make both tabs visible
  const productTab = document.querySelector('.tab-products');
  const collectionTab = document.querySelector('.tab-collections');
  if (productTab) productTab.classList.remove('hidden');
  if (collectionTab) collectionTab.classList.remove('hidden');

  // Always fetch both products AND collections — even for SKU searches
  const url = `${routes.predictive_search_url}?q=${encodeURIComponent(query)}&resources[type]=product,collection&resources[options][unavailable_products]=show&resources[options][fields]=title,variants.sku,product_type,variants.title&section_id=predictive-search`;

  fetch(url, {
    signal: this.abortController.signal
  })
    .then(response => {
      if (response.ok) return response.text();
      throw new Error(response.status);
    })
    .then(htmlString => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(htmlString, "text/html");
      const section = doc.querySelector("#shopify-section-predictive-search");

      if (!section) {
        throw new Error("Missing predictive search section in response");
      }

      const resultHTML = section.innerHTML;

      // Cache and render
      this.allPredictiveSearchInstances.forEach(inst => {
        inst.cachedResults[formattedQuery] = resultHTML;
      });

      this.renderSearchResults(resultHTML);
      this.clickSearchTabs();
      this.calcHeight();

      try {
        colorSwatches();
      } catch (_) {}
    })
    .catch(err => {
      if (err?.code !== 20) {
        this.close();
        console.error("Predictive search error:", err);
      }
    });

  this.getQuery().length ? this.hidePromoBlock() : this.showPromoBlock();
}

  setLiveRegionLoadingState() {
    (this.statusElement =
      this.statusElement || this.querySelector(".predictive-search-status")),
      (this.loadingText =
        this.loadingText || this.getAttribute("data-loading-text")),
      this.setLiveRegionText(this.loadingText),
      this.setAttribute("loading", !0);
  }
  setLiveRegionText(e) {
    this.statusElement.setAttribute("aria-hidden", "false"),
      (this.statusElement.textContent = e),
      setTimeout(() => {
        this.statusElement.setAttribute("aria-hidden", "true");
      }, 1e3);
  }
  renderSearchResults(e) {
    (this.predictiveSearchResults.innerHTML = e),
      this.setAttribute("results", !0),
      this.setLiveRegionResults(),
      this.open(),
      this.promoModal &&
        this.classList.contains("search-modal__form") &&
        this.promoModal.classList.add("search__modal--hidden"),
      this.collectionList && this.collectionList.classList.add("hidden");
  }
clickSearchTabs() {
    const resultsLists = this.querySelectorAll(".predictive-search__results-list");
    const searchInput = this.querySelector("input[type='search']"); // ✅ Add this if not present
    const closeSearch = this.querySelector(".predictive-search__close-button"); // ✅ optional button to close search

    if (resultsLists.length != 0) {
        resultsLists[0].classList.add("active");
        this.querySelector(".predictive-search__result-tab").classList.add("active");

        // Add overflow-hidden to body
        document.body.classList.add("overflow-hidden"); // ✅

        this.querySelectorAll(".predictive-search__result-tab").forEach(tab => {
            tab.addEventListener("click", e => {
                e.preventDefault();
                const targetType = tab.dataset.typeTarget;

                // Remove active from all tabs
                this.querySelectorAll(".predictive-search__result-tab").forEach(el => el.classList.remove("active"));
                tab.classList.add("active");

                // Toggle results
                let isActiveFound = false;
                resultsLists.forEach(el => {
                    if (el.dataset.type === targetType) {
                        el.classList.add("active");
                        isActiveFound = true;
                    } else {
                        el.classList.remove("active");
                    }
                });

                // Toggle body class
                if (isActiveFound) {
                    document.body.classList.add("overflow-hidden");
                } else {
                    document.body.classList.remove("overflow-hidden");
                }
            });
        });

        // ✅ Search input listener to remove class when input is cleared
        if (searchInput) {
            searchInput.addEventListener("input", () => {
                if (searchInput.value.trim() === "") {
                    document.body.classList.remove("overflow-hidden");
                    resultsLists.forEach(el => el.classList.remove("active"));
                    this.querySelectorAll(".predictive-search__result-tab").forEach(el => el.classList.remove("active"));
                }
            });
        }

        // ✅ Optional: close button to remove class when user closes search
        if (closeSearch) {
            closeSearch.addEventListener("click", () => {
                document.body.classList.remove("overflow-hidden");
                resultsLists.forEach(el => el.classList.remove("active"));
                this.querySelectorAll(".predictive-search__result-tab").forEach(el => el.classList.remove("active"));
            });
        }
    }
}
  hidePromoBlock() {
    this.classList.contains("search-modal__form") &&
      (this.promoModal &&
        this.promoModal.classList.add("search__modal--hidden"),
      this.collectionList) &&
      this.collectionList.classList.add("hidden");
  }
  showPromoBlock() {
    this.classList.contains("search-modal__form") &&
      (this.promoModal &&
        this.promoModal.classList.remove("search__modal--hidden"),
      this.collectionList) &&
      this.collectionList.classList.remove("hidden");
  }
  setLiveRegionResults() {
    this.removeAttribute("loading"),
      this.setLiveRegionText(
        this.querySelector("[data-predictive-search-live-region-count-value]")
          .textContent
      );
  }
  open() {
    this.setAttribute("open", !0),
      this.input.setAttribute("aria-expanded", !0),
      (this.isOpen = !0),
      this.getQuery().length ? this.hidePromoBlock() : this.showPromoBlock();
  }
  close(e = !1) {
    this.closeResults(e), (this.isOpen = !1);
  }
  closeResults(e = !1) {
    e && ((this.input.value = ""), this.removeAttribute("results"));
    e = this.querySelector('[aria-selected="true"]');
    e && e.setAttribute("aria-selected", !1),
      this.input.setAttribute("aria-activedescendant", ""),
      this.removeAttribute("loading"),
      this.removeAttribute("open"),
      this.input.setAttribute("aria-expanded", !1),
      this.predictiveSearchResults.removeAttribute("style"),
      this.getQuery().length ? this.hidePromoBlock() : this.showPromoBlock();
  }
}
customElements.define("predictive-search", PredictiveSearch);
